import RSVPDeclinedInvitationOverlay from './RSVPDeclinedInvitationOverlay';
export default RSVPDeclinedInvitationOverlay;
